import { CustomerAccountRowResult } from "@tastyworks/tastyworks-api"
import { writable } from "svelte/store"

const defaultCustomerAccount = new CustomerAccountRowResult()

const store = writable(defaultCustomerAccount)

export const selectedCustomerAccount = {
  ...store,
  reset: () => store.set(defaultCustomerAccount),
}
